export default {"src":"/_next/static/media/carousell.9bdea557.svg","height":31,"width":142,"blurWidth":0,"blurHeight":0};